import React from 'react';
import {
  isToday,
  isYesterday,
  isThisWeek,
  isThisMonth,
  format,
} from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { type TimelineEvent } from '@/hooks/useTimelineDecisoes';
import { TimelineEventCard } from './TimelineEventCard';

function getDateGroupLabel(dateStr: string): string {
  const date = new Date(dateStr);
  if (isToday(date)) return 'Hoje';
  if (isYesterday(date)) return 'Ontem';
  if (isThisWeek(date, { weekStartsOn: 1 })) return 'Esta Semana';
  if (isThisMonth(date)) return 'Este Mês';
  return format(date, "MMMM 'de' yyyy", { locale: ptBR });
}

function groupByDate(events: TimelineEvent[]): { label: string; events: TimelineEvent[] }[] {
  const groups: { label: string; events: TimelineEvent[] }[] = [];
  let currentLabel = '';

  for (const event of events) {
    const label = getDateGroupLabel(event.created_at);
    if (label !== currentLabel) {
      currentLabel = label;
      groups.push({ label, events: [] });
    }
    groups[groups.length - 1].events.push(event);
  }

  return groups;
}

interface Props {
  events: TimelineEvent[];
  onSelectEvent: (event: TimelineEvent) => void;
}

export const TimelineDateGroups: React.FC<Props> = ({ events, onSelectEvent }) => {
  const groups = groupByDate(events);

  return (
    <div className="space-y-6 max-w-3xl mx-auto pl-1 sm:pl-2">
      {groups.map((group) => (
        <div key={group.label}>
          {/* Date group header */}
          <div className="flex items-center gap-3 mb-3">
            <div className="h-px flex-1 bg-border/40" />
            <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wider px-2">
              {group.label}
            </span>
            <div className="h-px flex-1 bg-border/40" />
          </div>

          {/* Events */}
          <div className="space-y-0">
            {group.events.map((event, i) => (
              <TimelineEventCard
                key={`${event.tipo}-${event.id}`}
                event={event}
                onSelect={onSelectEvent}
                isLast={i === group.events.length - 1}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
